var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 33C31.3241 33 37.8002 25 37.8002 25C37.8002 25 31.3242 17 25.0002 17C18.6762 17 12.2002 25 12.2002 25C12.2002 25 18.6762 33 25.0002 33ZM25.0002 21.4C27.1202 21.4 28.8403 23.0119 28.8403 24.9999C28.8403 26.9879 27.1205 28.5997 25.0002 28.5997C22.8802 28.5997 21.1601 26.9879 21.1601 24.9999C21.1601 23.0119 22.8802 21.4 25.0002 21.4Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8527 25.0001C25.8527 25.4421 25.471 25.8001 25.0006 25.8001C24.5301 25.8001 24.1484 25.4421 24.1484 25.0001C24.1484 24.5582 24.5301 24.2002 25.0006 24.2002C25.471 24.2002 25.8527 24.5582 25.8527 25.0001Z",
    fill: "#BEBEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4004 11H25.6005V14.5999H24.4004V11Z",
    fill: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7402 15.2494L14.5887 14.4009L17.1795 16.9916L16.3309 17.8401L13.7402 15.2494Z",
    fill: "#BEBEBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 16.9916L35.411 14.4009L36.2595 15.2494L33.6688 17.8401L32.8203 16.9916Z",
    fill: "#BEBEBE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7412 34.7513L16.3319 32.1606L17.1804 33.0091L14.5897 35.5998L13.7412 34.7513Z",
    fill: "#BEBEBE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 33.0087L33.6688 32.1602L36.2595 34.7509L35.411 35.5994L32.8203 33.0087Z",
    fill: "#BEBEBE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4004 35.3999H25.6005V38.9998H24.4004V35.3999Z",
    fill: "#BEBEBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetect);
export default __webpack_public_path__ + "static/media/Detect.99c506348c9e80ea6d1c5340733d6506.svg";
export { ForwardRef as ReactComponent };